<template>
  <div class="navigation-container">
    <div class="navigation-mobile">
      <div class="navigation">
        <!-- <div class="logo" @click="goToIndex"></div> -->
        <svg width="78" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="goToIndex">
          <g clip-path="url(#clip0)" fill="#000">
            <path
              d="M30.236.83h-2.343v14.944h2.343V.83zM20.668 4.504c-3.104 0-5.629 2.493-5.629 5.556s2.525 5.555 5.629 5.555c3.103 0 5.628-2.492 5.628-5.555 0-3.063-2.525-5.556-5.628-5.556zm0 8.93c-1.875 0-3.4-1.514-3.4-3.374s1.525-3.374 3.4-3.374c1.873 0 3.398 1.514 3.398 3.374s-1.524 3.373-3.398 3.373zM37.47 4.504c-3.103 0-5.628 2.493-5.628 5.556s2.525 5.555 5.628 5.555c3.104 0 5.629-2.492 5.629-5.555 0-3.063-2.525-5.556-5.629-5.556zm0 8.93c-1.874 0-3.398-1.514-3.398-3.374s1.524-3.374 3.398-3.374 3.4 1.514 3.4 3.374-1.526 3.373-3.4 3.373zM57.893.256c-4.237 0-7.684 3.532-7.684 7.872S53.656 16 57.893 16c4.236 0 7.683-3.532 7.683-7.872S62.13.256 57.893.256zm0 13.562c-3.008 0-5.454-2.552-5.454-5.69 0-3.137 2.446-5.69 5.454-5.69 3.007 0 5.454 2.553 5.454 5.69 0 3.138-2.447 5.69-5.454 5.69zM7.684 2.182c1.605 0 3.276.779 4.852 2.552l1.516-1.29C12.66 1.465 10.293 0 7.684 0 3.447 0 0 3.531 0 7.872c0 4.34 3.447 7.871 7.684 7.871 2.645 0 4.807-1.285 6.325-3.497l-1.655-1.259c-.485.541-2.038 2.562-4.67 2.575-3.008.014-5.454-2.553-5.454-5.69 0-3.138 2.446-5.69 5.454-5.69zM44.654 8.444l.003 7.213H47V8.775s-.019-.816.272-1.275c.186-.293.51-.667 1.377-.77V4.462c-2.653 0-3.995 2.233-3.995 3.982zM76.207 8.206c-.697-.514-1.793-.852-2.733-1.092a67.929 67.929 0 01-2.33-.647c-1.354-.4-1.97-1.065-1.937-1.913.038-.983.767-1.862 2.246-2.09 2.378-.365 4.115.684 4.863 1.262l1.381-1.604c-1.057-.86-3.375-2.308-6.59-1.813-2.35.362-4.009 2.095-4.126 4.122-.113 1.935 1.135 3.368 3.565 4.025.688.186 1.7.402 2.634.667.647.184 1.64.45 2.172 1.123.411.519.478 1.143.454 1.474-.031.425-.302 1.745-1.922 2.066-1.527.303-3.735.052-6.032-2.027l-1.416 1.56c2.683 2.616 5.605 2.958 7.875 2.508C76.108 15.472 78 14.054 78 11.592c0-1.428-.714-2.591-1.793-3.386z"
            />
          </g>
          <defs>
            <clipPath id="clip0"><path fill="none" d="M0 0h78v16H0z" /></clipPath>
          </defs>
        </svg>
        <div
          v-if="lang === 'zh'"
          v-show="menuStatusClass === 'active'"
          class="search-icon"
          @click="handleSearchIconClick"
        ></div>
        <div :class="['navigation-line', menuStatusClass]" @click="handleMenuClick">
          <div class="navigation-line-top"></div>
          <div class="navigation-line-bottom"></div>
        </div>
      </div>
    </div>
    <div class="navigation-pc">
      <div class="logo" @click="goToIndex">
        <a>
          <svg width="78" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)" fill="#000">
              <path
                d="M30.236.83h-2.343v14.944h2.343V.83zM20.668 4.504c-3.104 0-5.629 2.493-5.629 5.556s2.525 5.555 5.629 5.555c3.103 0 5.628-2.492 5.628-5.555 0-3.063-2.525-5.556-5.628-5.556zm0 8.93c-1.875 0-3.4-1.514-3.4-3.374s1.525-3.374 3.4-3.374c1.873 0 3.398 1.514 3.398 3.374s-1.524 3.373-3.398 3.373zM37.47 4.504c-3.103 0-5.628 2.493-5.628 5.556s2.525 5.555 5.628 5.555c3.104 0 5.629-2.492 5.629-5.555 0-3.063-2.525-5.556-5.629-5.556zm0 8.93c-1.874 0-3.398-1.514-3.398-3.374s1.524-3.374 3.398-3.374 3.4 1.514 3.4 3.374-1.526 3.373-3.4 3.373zM57.893.256c-4.237 0-7.684 3.532-7.684 7.872S53.656 16 57.893 16c4.236 0 7.683-3.532 7.683-7.872S62.13.256 57.893.256zm0 13.562c-3.008 0-5.454-2.552-5.454-5.69 0-3.137 2.446-5.69 5.454-5.69 3.007 0 5.454 2.553 5.454 5.69 0 3.138-2.447 5.69-5.454 5.69zM7.684 2.182c1.605 0 3.276.779 4.852 2.552l1.516-1.29C12.66 1.465 10.293 0 7.684 0 3.447 0 0 3.531 0 7.872c0 4.34 3.447 7.871 7.684 7.871 2.645 0 4.807-1.285 6.325-3.497l-1.655-1.259c-.485.541-2.038 2.562-4.67 2.575-3.008.014-5.454-2.553-5.454-5.69 0-3.138 2.446-5.69 5.454-5.69zM44.654 8.444l.003 7.213H47V8.775s-.019-.816.272-1.275c.186-.293.51-.667 1.377-.77V4.462c-2.653 0-3.995 2.233-3.995 3.982zM76.207 8.206c-.697-.514-1.793-.852-2.733-1.092a67.929 67.929 0 01-2.33-.647c-1.354-.4-1.97-1.065-1.937-1.913.038-.983.767-1.862 2.246-2.09 2.378-.365 4.115.684 4.863 1.262l1.381-1.604c-1.057-.86-3.375-2.308-6.59-1.813-2.35.362-4.009 2.095-4.126 4.122-.113 1.935 1.135 3.368 3.565 4.025.688.186 1.7.402 2.634.667.647.184 1.64.45 2.172 1.123.411.519.478 1.143.454 1.474-.031.425-.302 1.745-1.922 2.066-1.527.303-3.735.052-6.032-2.027l-1.416 1.56c2.683 2.616 5.605 2.958 7.875 2.508C76.108 15.472 78 14.054 78 11.592c0-1.428-.714-2.591-1.793-3.386z"
              />
            </g>
            <defs>
              <clipPath id="clip0"><path fill="none" d="M0 0h78v16H0z" /></clipPath>
            </defs>
          </svg>
        </a>
      </div>
      <div class="navigation-pc-line">
        <div v-for="(item, index) in menuData" :key="index" class="line-item">
          <a :href="item.url">
            {{ isInI18n ? $t(item.name) : item.name }}
          </a>
        </div>
        <div
          v-if="lang === 'zh'"
          class="line-item search-icon"
          :class="{ close: searchVisible }"
          @click="searchVisible = !searchVisible"
        ></div>
      </div>
    </div>
    <navigation-menu :viaibled="viaibled" :menu-data="menuData" :is-in-i18n="isInI18n"></navigation-menu>
    <navigation-search
      v-if="lang === 'zh' && searchVisible"
      :class="{ 'search-mask-show': searchVisible, 'search-pc': !visible }"
      :visible="visible"
      :search-visible="searchVisible"
    >
    </navigation-search>
  </div>
</template>

<script>
import NavigationMenu from '@/components/Menu';
import NavigationSearch from '@/components/SearchBox';
export default {
  inject: {
    lang: { default: 'zh' },
    vm: { default: { config: {} } }
  },
  components: { NavigationMenu, NavigationSearch },
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const isInI18n = !!this.$t;
    return {
      viaibled: false,
      searchVisible: false,
      menuStatusClass: '',
      navigationMenu: '',
      isInI18n
    };
  },
  computed: {
    menuData() {
      const isInI18n = !!this.$t;
      const menuData = [
        {
          index: 0,
          name: 'ColorOS 11',
          url: `https://www.coloros.com/${this.lang === 'zh' ? 'feature' : this.lang}/coloros11`
        },
        {
          index: 1,
          name: isInI18n ? 'nav-rom' : '下载',
          url: `https://www.coloros.com/${this.lang === 'zh' ? '' : `${this.lang}/`}rom`
        },
        {
          index: 2,
          name: isInI18n ? 'nav-community' : '社区',
          url: this.lang === 'zh' ? 'https://www.oppo.cn/list-950-1' : 'https://community.coloros.com/forum.php'
        },
        {
          index: 3,
          name: isInI18n ? 'nav-cloud-service' : '云服务',
          url: this.lang === 'zh' ? 'https://cloud.oppo.com/login.html' : 'https://cloud.oppo.com/login.html'
        }
      ];
      if (this.lang !== 'zh' && !this.vm.config.hideOppo) {
        menuData.push({
          index: 4,
          name: 'OPPO',
          url: `https://www.oppo.com/${this.lang}`
        });
      }
      if (this.vm.config.hideCloud) menuData.splice(3, 1);
      if (this.vm.config.hideBBS) menuData.splice(2, 1);
      if (this.vm.config.hideRom) menuData.splice(1, 1);
      if (this.vm.config.hideColorOSVersion) menuData.splice(0, 1);
      return menuData;
    }
  },
  methods: {
    goToIndex() {
      location.href = `https://www.coloros.com${this.lang === 'zh' ? '' : `/${this.lang}`}`;
    },
    showBgImage(val) {
      this.$emit('setImgBg', val);
    },

    handleBackClick() {
      this.$router.goBack();
    },
    handleClose() {},
    handleMenuClick() {
      this.menuStatusClass ? (this.menuStatusClass = '') : (this.menuStatusClass = 'active');
      if (this.viaibled) {
        this.viaibled = false;
      } else {
        this.viaibled = true;
      }
    },
    handleSearchIconClick() {
      this.searchVisible = true;
      this.viaibled = false;
      this.menuStatusClass = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.navigation-container {
  position: absolute;
  width: 100%;
}
.navigation-mobile {
  display: none;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
}

.navigation {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 99;
  .logo {
    width: 76px;
    height: 20px;
  }
  .search-icon {
    position: absolute;
    right: 55px;
    top: 22px;
    width: 18px;
    height: 17px;
    background: url('../assets/common/search.png') no-repeat 50%;
    background-size: contain;
    animation: opacityShow 0.4s ease-in-out;
  }
  &-line {
    position: relative;
    width: 20px;
    height: 10px;
    div {
      position: absolute;
      width: 20px;
      height: 1px;
      border-top: 2px solid #000;
    }
    &-top {
      top: 0;
      transform: none;
      transition: all 0.3s ease-in-out;
    }
    &-bottom {
      transform: none;
      top: 10px;
      transition: all 0.3s ease-in-out;
    }
    &::after {
      content: '';
      height: 27px;
      position: absolute;
      width: 30px;
      left: -5px;
      top: -7px;
    }
  }

  .navigation-line.active {
    div {
      position: absolute;
      top: 3px;
    }
    .navigation-line-top {
      border-color: #000 !important;
      transform: rotate(45deg);
      transition: all 0.3s ease-in-out;
    }
    .navigation-line-bottom {
      border-color: #000 !important;
      transform: rotate(-45deg);
      margin-top: 0px;
      transition: all 0.3s ease-in-out;
    }
  }
}

.navigation-pc {
  position: relative;
  box-sizing: border-box;
  //width: 100%;
  /* width: 1600px; */
  height: 104px;
  padding: 0 140px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 99;
  .logo {
    width: 76px;
    height: 20px;
    cursor: pointer;
    a {
      display: block;
      height: 20px;
      width: 89px;
      background-size: contain;
      font-size: 0;
      transition: all 1.2s ease-in-out;
      path {
        fill: #000;
      }
    }
  }
  &-line {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .line-item {
      margin-left: 60px;
      line-height: 30px;
      a {
        color: #000;
        text-decoration: none;
      }
    }

    .line-item :hover {
      opacity: 0.2;
      cursor: pointer;
    }

    .search-icon {
      min-width: 16px;
      min-height: 16px;
      background: url('../assets/common/search.png') no-repeat 50%;
      background-size: contain;
      cursor: pointer;
    }
    .close {
      min-width: 16px;
      min-height: 16px;
      background-image: url('../assets/common/cloesd.png');
      background-size: 120% 120%;
    }
  }
}
.search-mask-show {
  opacity: 1;
  transition: all 0.5s ease-in-out;
  animation: opacityShow 0.5s ease-in-out;
}

@media screen and (max-width: 1440px) {
  .navigation-pc {
    padding: 0 10vw;
  }
}
@media screen and (max-width: 960px) {
  .navigation-pc {
    padding: 0 1vw;
  }
}

@media screen and (max-width: 734px) {
  .navigation-mobile {
    display: block;
  }
  .navigation-pc {
    display: none;
  }
}

@keyframes opacityShow {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
